import { FormSection } from 'app/components/shared/FormSection'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { Location } from 'EstraSponsor'
import React from 'react'
import styled, { useTheme } from 'styled-components'

import { CompanyFormSection } from '../formSections/Company'
import { ContactsFormSection } from '../formSections/Contacts'
import { SecondaryAddressFormSection } from '../formSections/SecondaryAddress'

type Props = {
  userEmail: string
  locations: Location[]
}

export const UserDataInnerForm = ({
  userEmail,
  locations,
}: Props): JSX.Element => {
  const theme = useTheme()

  return (
    <Container>
      <Text variant='s12' mb={2}>
        (<StyledSpan>*</StyledSpan>) I campi contrassegnati con l&apos;asterisco
        sono obbligatori.
      </Text>
      <FormSection title='Dati di accesso'>
        <Text color={theme.color.primari.grigioEstra} variant='s16'>
          Username:
        </Text>
        <Text variant='s20' mb={1}>
          {userEmail}
        </Text>
      </FormSection>
      <FormSection title='Ditta, ente o associazione'>
        <CompanyFormSection />
      </FormSection>
      <FormSection title='Contatti'>
        <ContactsFormSection locations={locations} />
        <SecondaryAddressFormSection locations={locations} />
      </FormSection>
    </Container>
  )
}

const StyledSpan = styled.span`
  color: ${({ theme }) => theme.color.secondari.arancioneScuro};
`
